var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"where-to-buy-wrap"},_vm._l((_vm.stores),function(item){return _c('WhereToBuyItem',{key:item.id,attrs:{"store":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }